
  import { defineComponent, ref } from 'vue';
  import { useStore } from 'vuex';
  import { POST_MEMBER, PUT_MEMBER } from "@/store/member.module";
  
  export default defineComponent({
    props: {
      title: {
        type: String,
        required: true
      },
      id: {
        type: String,
        required: false
      },
      data: {
        type: Object,
        required: false,
        default: () => ({})
      }
    },
    setup(props, { emit }) {
      const store = useStore();
      const modalContent = ref(null);
      const isLoading = ref(false);
  
      const closeModal = () => {
        isLoading.value = false;
        emit('close');
      };
  
      const formData = {
        id: '',
        data: {} as Record<string, any>
      };
  
      const updateValue = (params: { key: string; value: any }) => {
        formData.data[params.key] = params.value;
      };
  
      const handleSubmit = async () => {
        isLoading.value = true;
        try {
          if (props?.id) {
            formData.id = props?.id;
            await store.dispatch(PUT_MEMBER, formData);
          } else {
            await store.dispatch(POST_MEMBER, formData);
          }
          closeModal();
        } catch (error) {
          console.error('Failed to create merchandise:', error);
          alert(error);
          isLoading.value = false;
        }
      };
  
      // Print function
      const printCard = () => {
        const printContents = document.getElementById("printableArea")?.innerHTML;
        const originalContents = document.body.innerHTML;
  
        if (printContents) {
          document.body.innerHTML = printContents;
          window.print();
          document.body.innerHTML = originalContents;
          window.location.reload(); // Reload to restore original content
        }
      };
  
      return {
        modalContent,
        closeModal,
        handleSubmit,
        updateValue,
        isLoading,
        printCard
      };
    },
  });
  